module.exports = __webpack_public_path__ + "static/chart-img-0e908b0270f8a96e0642436e833a9ac8.jpg";